import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { AppTranslateModule } from '@core/app-translate.module';

import { FormDropdownModule } from '../form-dropdown/form-dropdown.module';
import { FormInputYesNoModule } from '../form-input-yesno/form-input-yes-no.module';
import { FormInputModule } from '../form-input/form-input.module';
import { FormDatePickerModule } from '../form-date-picker/form-date-picker.module';

import { FormContactComponent } from './form-contact.component';
import { FormFileModule } from '../form-file/form-file.module';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  FormDropdownModule,
  FormInputModule,
  FormInputYesNoModule,
  FormFileModule,
  FormDatePickerModule,
];

@NgModule({
  declarations: [FormContactComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [FormContactComponent],
})
export class FormContactModule {}
